import { Component, DestroyRef, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { STANDARD_REMOTE_URL_PREFIX } from '../../consts';
import { RemoteApplicationLoaderService } from '../../remote-application-loader.service';

@Component({
	selector: 'itero-embedded-remote-application',
	standalone: true,
	templateUrl: 'embedded-remote-application.component.html',
})
export class EmbeddedRemoteApplicationComponent implements OnInit {
	@Input() appId: string;

	@ViewChild('rootElement', { read: ViewContainerRef, static: true })
	rootElementRef?: ViewContainerRef;

	constructor(private readonly destroyRef: DestroyRef, private readonly remoteApplicationLoaderService: RemoteApplicationLoaderService) {}

	async ngOnInit(): Promise<void> {
		if (!this.rootElementRef) {
			throw new Error('Container is not initialized');
		}

		if (!this.appId) throw new Error('[EmbeddedRemoteApplicationComponent] Missing appId');

		const appParameters = {
			basePath: `${STANDARD_REMOTE_URL_PREFIX}/${this.appId}`,
		};

		const renderOptions = {
			appId: this.appId,
			rootElement: this.rootElementRef.element.nativeElement as HTMLElement,
			destroyRef: this.destroyRef,
			appParameters,
		};

		await this.remoteApplicationLoaderService.renderRemote(renderOptions);
	}
}

